module.exports = __webpack_public_path__ + "editor/icon-editor-033da1278dd5a60cc0475ee408fb73cb.svg";